export const startsListArray = [
  {
    id: 1,
    starName: 'SID',
    fixOrder: 'TWO',
    fixName: 'FIX IS A NAME',
    country: 'Mexico',
  },
];
